import { Injectable, inject } from '@angular/core';

import { WINDOW_TOKEN } from '../window.token';
import { BrowserWindow } from './init-webview.service';

export type EasytradeNativePageId = 'navigateToQuote' |
                                    'navigateToOrderEntry' |
                                    'navigateToCashTransfer' |
                                    'navigateToTransferLanding' |
                                    'navigateToExploreLanding' |
                                    'navigateToAccountDetails';

@Injectable({
  providedIn: 'root'
})
export class EasytradeNativeService {
  private readonly window = inject<Partial<BrowserWindow>>(WINDOW_TOKEN);

  isNativeActive: boolean = false;

  /**
    Android puts isERT and navigateToNativeEasyTrade under window.ugobridge
    iOS exposes isERT and navigateToNativeEasyTrade just under window
  **/
  init(): void {
    this.isNativeActive = !!(this.window?.ugobridge?.isETR?.() || this.window?.isETR?.());
  }

  navigateToNative(pageId: EasytradeNativePageId, params?: Record<string, string>): void {
    const navigationParam: string = JSON.stringify({
      navigateAction: pageId,
      ...(params && { params })
    });

    if (this.window?.ugobridge?.navigateToNativeEasyTrade !== undefined) {
      this.window.ugobridge.navigateToNativeEasyTrade(navigationParam);
    } else if (this.window?.navigateToNativeEasyTrade !== undefined) {
      this.window.navigateToNativeEasyTrade(navigationParam);
    }
  }
}
